import {
  Component,
  ElementRef,
  Input,
  model,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
    selector: 'c-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrl: './radio-group.component.css',
    standalone: false
})
export class RadioGroupComponent {
  @Input() title = 'Esto es un título';
  @Input() options!: any;
  @Input() optionLabel = '';
  @Input() name!: string;
  option = model<any>();
  getItem(item: any) {
    this.option.set(item);
    // this.radioButtons.forEach((radio) => {
    //   if (this.option() ? radio.nativeElement.id == this.option().id : false)
    //     radio.nativeElement.checked = true;
    // });
  }

  @ViewChildren('radioButton') radioButtons!: QueryList<
    ElementRef<HTMLInputElement>
  >;
  clearSelection() {
    this.radioButtons.forEach((radio) => (radio.nativeElement.checked = false));
    this.option.set(null);
  }
}
